import * as Sentry from '@sentry/vue'

export function processSentry(error: any) {
  Sentry.withScope((scope) => {
    if (error?.response) {
      scope.addBreadcrumb({
        category: 'response-data',
        message: JSON.stringify(error.response.data, null, 4)
      })
      scope.addBreadcrumb({
        category: 'status',
        message: error.response.status
      })
    }
    if (error?.config) {
      const scopeUrl = error.config.url?.replace(/\d+/g, 'X') ?? ''
      const method = error.config.method
      const status = error.response?.status ?? '{no status}'
      error.message = `AxiosError ${status} ${method} ${scopeUrl}`
      scope.addBreadcrumb({
        category: 'request-data',
        message: error.config.data
      })
      scope.addBreadcrumb({
        category: 'path',
        message: error.config.url
      })
      scope.addBreadcrumb({
        category: 'method',
        message: error.config.method
      })
      scope.addBreadcrumb({
        category: 'scope',
        message: scopeUrl
      })
      scope.setFingerprint([
        error.config.method,
        scopeUrl,
        String(error.response?.status ?? 500)
      ])
    }
    if (error?.response?.status >= 401) {
      Sentry.captureException(error)
    } else {
      error.message = (error.message ?? '') + '[IGNORE]'
    }
  })
}
